import { render, staticRenderFns } from "./PropertyDetails2.vue?vue&type=template&id=6e29cc27&scoped=true&"
import script from "./PropertyDetails2.vue?vue&type=script&lang=js&"
export * from "./PropertyDetails2.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetails2.vue?vue&type=style&index=0&id=6e29cc27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e29cc27",
  null
  
)

export default component.exports